const About = () => {
    return (
        <div className={'about-container'}>
            <iframe className={'about-iframe'} src={'./about.html'}></iframe>
        </div>
    )
}

export default About;